import router from "@/router";
import store from "@/stores";
import Ajax from "@/utils/DuduAjax";
import { API_BIS_PROJECT } from "@/configs/Apis";

router.beforeEach(async (to, from, next) => {
  const project = (store.state as any).project;
  let projectId = to.params.projectId;

  if (project.info === null || project.info === undefined) {
    const foundRouters = to.matched.filter((r) => (r.meta.inProject as any) === true); // 是否需要加载项目数据
    if (foundRouters.length) {
      // 项目ID为空，尝试在路由配置中寻找项目ID
      if (!projectId) {
        const mainRouter = foundRouters.find((r) => Object.prototype.hasOwnProperty.call(r.meta, "projectId"));
        if (mainRouter) {
          projectId = mainRouter.meta.projectId;
        }
      }
      if (projectId) {
        const data = await Ajax.get<Array<any>>({ url: API_BIS_PROJECT, path: { id: projectId } });
        if (data) {
          await store.dispatch("project/setProjectInfo", data);
        }
      }
    }
  }
  next();
});
